// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__GE-62","overlay":"Loader_overlay__yBBiM"};